import { PLP_BASE_PATH } from '@/plp/helpers/getPlpSlug';

export const SMART_SEARCH_WORD_THRESHOLD = 2;

export const SMART_SEARCH_PATH = `${PLP_BASE_PATH}/smart-search`;

const countWords = (term: string): number => term.split(/\s+/).filter(Boolean).length;

export const isNaturalLanguageTerm = (term: string): boolean => countWords(term.trim()) > SMART_SEARCH_WORD_THRESHOLD;

export const getKeywordSearchPath = (term: string): string => `${PLP_BASE_PATH}/'${term}'`;

export const getSearchDestination = (term: string): string => {
  const trimmed = term.trim();

  if (!trimmed) {
    return PLP_BASE_PATH;
  }

  if (isNaturalLanguageTerm(trimmed)) {
    return `${SMART_SEARCH_PATH}?query=${encodeURIComponent(trimmed)}`;
  }

  return getKeywordSearchPath(trimmed);
};
